import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "map-base-container"
};
const _hoisted_2 = {
  style: {
    "width": "240px",
    "height": "32px"
  }
};
const _hoisted_3 = {
  class: "map-core-container"
};
import { ref, onMounted, computed, watch, nextTick } from 'vue';
import { ElRow, ElSelect } from "element-plus";
import { mapSpriteResources, mapPieceResources, stageMapTypes } from "@/tools/utils";
import { drawCircleAvatar, loadNetImage, loadSpriteSheet } from "@/tools/mapImageTool";
import store from "@/store";
import MaskerLayer from "@/components/Basic/MaskerLayer.vue";
import MapGenerator from "@/components/Stage/MapGenerator.vue";
import MapCore from "@/components/Stage/MapCore.vue";
import MapPieceManager from "@/components/Stage/MapPieceManager.vue"; // constants

export default {
  __name: 'MapContainer',
  props: {
    mapData: {
      type: Object,
      required: true
    },
    role: {
      type: [Object, null],
      required: true
    },
    actor: {
      type: Array,
      required: true
    }
  },
  emits: ['update-map-data', 'delete-map-data'],

  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const defaultMapData = {
      type: 0,
      name: '',
      width: 20,
      height: 14,
      data: {}
    }; // pre-declarations

    const props = __props;
    const emits = __emit; // refs

    const mapCore = ref(null);
    const centerCoord = ref([0, 0]);
    const currentMapId = ref(null);
    const isCreating = ref(false);
    const isPieceSetup = ref(false);
    const operatingCell = ref(null);
    const operatingPiece = ref(null);
    const operatingPieceRef = ref(null); // computed

    const cachedImages = computed(() => store.state.map_images);
    const currentMapData = computed(() => {
      if (props.mapData === null || currentMapId.value === null) return null;
      if (!Object.keys(props.mapData).includes(currentMapId.value)) return null;
      const mapData = props.mapData[currentMapId.value]; // console.log(`mapData = ${JSON.stringify(mapData)}`)

      return {
        'map_id': currentMapId.value,
        ...mapData
      };
    });
    const currentMapPieceData = computed(() => {
      if (currentMapData.value === null) return null;
      return currentMapData.value.piece_data ?? {};
    });
    const operatingCells = computed(() => {
      if (operatingCell.value === null) return [];
      return [operatingCell.value];
    }); // functions

    const getMapTitle = item => {
      let mapType = '';

      if (stageMapTypes.map(item => item.id).includes(item.type)) {
        mapType = `【${stageMapTypes[item.type].name}】`;
      }

      return `${mapType} ${item.name}`;
    };

    const redraw = () => {
      if (mapCore.value) mapCore.value.requestRender();
    };

    const updateCenterCoord = coord => {
      if (coord && coord.length === 2) {
        centerCoord.value = coord;
      }
    }; // const resetCoord = () => {
    //   if (mapCore.value) {
    //     centerCoord.value = [0, 0]
    //     mapCore.value.setCenterCoord(centerCoord.value)
    //   }
    // }


    const selectedCell = coord => {
      if (currentMapData.value === null || props.role === null) return;
      if (!coord || coord.length !== 2) return;
      let cellKey = null;

      if (props.role.position === 'apostle') {
        cellKey = coord.join(',');
      } else if (props.role.position === 'actor' && currentMapData.value.type === 1) {
        cellKey = coord.join(',');
      }

      if (cellKey === null) return;

      if (operatingCell.value === cellKey) {
        cancelOperatingPiece();
        return;
      }

      if (Object.keys(currentMapPieceData.value).includes(cellKey)) {
        operatingPiece.value = currentMapPieceData.value[cellKey];
      } else if (operatingPiece.value !== null) {
        let mapData = structuredClone(currentMapData.value);
        delete mapData.piece_data[operatingCell.value];
        mapData.piece_data[cellKey] = operatingPiece.value;
        mapDataUpdate(mapData);
      }

      operatingCell.value = cellKey;
      redraw();
      nextTick(() => {
        drawOperatingPiece();
      });
    };

    const drawOperatingPiece = async () => {
      if (!operatingPieceRef.value || !operatingPiece.value) return;
      const pieceSize = 96;
      const ctx = operatingPieceRef.value.getContext('2d');
      ctx.clearRect(0, 0, pieceSize, pieceSize); // console.log(`drawOperatingPiece ${JSON.stringify(operatingPiece.value)}`)

      const imageData = operatingPiece.value;
      const longSide = Math.max(imageData.width, imageData.height);
      const scale = pieceSize / longSide;
      const offsetX = pieceSize * 0.5 - imageData.width * scale * 0.5;
      const offsetY = pieceSize * 0.5 - imageData.height * scale * 0.5;
      drawCircleAvatar(ctx, cachedImages.value[imageData.imagePath], imageData.x, imageData.y, imageData.width, imageData.height, offsetX, offsetY, scale, '#444444', 1);
    };

    const placePiece = pieceInfo => {
      if (operatingCell.value === null) return;
      let mapData = structuredClone(currentMapData.value);
      if (!mapData['piece_data']) mapData['piece_data'] = {};
      mapData.piece_data[operatingCell.value] = pieceInfo;
      mapDataUpdate(mapData);
      operatingPiece.value = pieceInfo;
      nextTick(() => {
        drawOperatingPiece();
      });
    };

    const takePiece = () => {
      if (operatingCell.value === null || operatingPiece.value === null) return;
      let mapData = structuredClone(currentMapData.value);
      delete mapData.piece_data[operatingCell.value];
      mapDataUpdate(mapData);
      cancelOperatingPiece();
    };

    const cancelOperatingPiece = () => {
      operatingCell.value = null;
      operatingPiece.value = null;
      redraw();
    };

    const mapGenerator = () => {
      isCreating.value = true;
    };

    const mapDataUpdate = mapData => {
      emits('update-map-data', mapData);
    };

    const mapDataDelete = mapId => {
      emits('delete-map-data', mapId);
    };

    const loadSpriteResources = async () => {
      // await loadSpriteSheets(spriteSheetNames)
      const spriteSheetNames = [...mapSpriteResources.map(item => item.pngFile), ...mapPieceResources.map(item => item.pngFile)];

      for (const sheetName of spriteSheetNames) {
        const sheetImage = await loadSpriteSheet(sheetName);
        store.commit('update_map_images', {
          'imageName': sheetName,
          'image': sheetImage
        });
      }

      for (const role of props.actor) {
        const avatarImage = await loadNetImage(role.avatar);
        store.commit('update_map_images', {
          'imageName': `cast:${role.id}`,
          'image': avatarImage
        });
      }
    }; // lifecycle


    onMounted(() => {
      loadSpriteResources();
    }); // watcher

    watch(() => props.mapData, newVal => {
      if (newVal) {
        const mapIds = Object.keys(newVal);

        if (currentMapId.value !== null && !mapIds.includes(currentMapId.value)) {
          currentMapId.value = null;
        }

        if (mapIds.length > 0 && currentMapId.value === null) {
          currentMapId.value = Object.keys(newVal)[0];
        }
      }
    }, {
      immediate: true
    });
    watch(() => currentMapData.value, (newValue, oldValue) => {
      // console.log(JSON.stringify(newValue))
      if (newValue) {
        nextTick(() => redraw());
      }

      if (!oldValue || !newValue || oldValue.map_id !== newValue.map_id) {
        operatingCell.value = null;
        operatingPiece.value = null;
      }
    }, {
      deep: true,
      immediate: true
    }); // post-declaration

    __expose({
      mapGenerator
    });

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        class: "map-options-container"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElSelect), {
          modelValue: currentMapId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentMapId.value = $event),
          "show-arrow": false,
          "popper-class": "commonPopper"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(__props.mapData), ([key, item], index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: getMapTitle(item),
              value: key
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createVNode(MapCore, {
        ref_key: "mapCore",
        ref: mapCore,
        "map-data": currentMapData.value ?? defaultMapData,
        locked: true,
        "show-center-coords": false,
        "show-coords": false,
        "operating-cells": operatingCells.value,
        onUpdateCenterCoord: updateCenterCoord,
        onClickCell: selectedCell
      }, null, 8, ["map-data", "operating-cells"])]), operatingCell.value !== null ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["role-indicator-container", {
          'hasPiece': operatingPiece.value !== null
        }])
      }, [_createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [operatingPiece.value === null ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: _cache[1] || (_cache[1] = $event => isPieceSetup.value = true)
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" 加入棋子 ", -1)]))]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: takePiece
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" 移除棋子 ", -1)]))]),
          _: 1
        }))]),
        _: 1
      })], 2)) : _createCommentVNode("", true), isCreating.value ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 1,
        onClose: _cache[3] || (_cache[3] = $event => isCreating.value = false)
      }, {
        default: _withCtx(() => [_createVNode(MapGenerator, {
          "map-data": __props.mapData,
          "default-map-id": currentMapId.value,
          onSubmitUpdates: mapDataUpdate,
          onSubmitDelete: mapDataDelete,
          onClose: _cache[2] || (_cache[2] = $event => isCreating.value = false)
        }, null, 8, ["map-data", "default-map-id"])]),
        _: 1
      })) : _createCommentVNode("", true), isPieceSetup.value ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 2,
        onClose: _cache[5] || (_cache[5] = $event => isPieceSetup.value = false)
      }, {
        default: _withCtx(() => [_createVNode(MapPieceManager, {
          actor: __props.actor,
          onPlacePiece: placePiece,
          onClose: _cache[4] || (_cache[4] = $event => isPieceSetup.value = false)
        }, null, 8, ["actor"])]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }

};